<template>
  <div class="l28-lht" style="background: linear-gradient(#7a58eb, #6f95fa); min-height: 1450px;">
    <div style="background: #fff;"> 
      <div style="width:1400px; margin:0 auto; padding:10px 0;">
        <PageHeader style="margin:10px 0 0 0;"/>
        <div style="padding: 20px 30px;">
          日期：<a-date-picker style="width:210px" :allowClear="false" v-model="ds" @change="(date, dateStr)=>getData(dateStr)" :disabled-date="disabledRangeDate" />
          <span style="margin: 0 0 0 20px">巡回赛：</span>
          <a-select style="width: 300px" v-model="tour_id">
            <a-select-option :value="tour.id" :label="tour.name" v-for="tour in tours" :key="tour.id"><a-tag color="blue">{{tour.ts}}</a-tag>{{tour.name}}</a-select-option>
          </a-select>
        </div>
      </div>
    </div>
    <div style="width:1400px; margin:0 auto; padding:10px 0; color:#fff;">
    </div>
    <div class="l28_ctrl_container" v-if="tour">
      <div class="l28_tour_names">
        <div>QUALIFIER</div>
        <div>ROUND 1</div>
        <div>QUARTERS</div>
        <div>SEMI</div>
        <div>FINAL</div>
      </div>
      <div class="l28_tour_maps">
        <div class="l28-groups groups-qualifier">
          <Group 
            :key="`${tour.id}_${group}`"
            :name="GROUP_NAMES[group]" 
            :players="tour.groups[group+1]" 
            v-for="(group, gi) in [15, 16, 17, 18, 19, 20, 21, 22, ]" 
            :style="{ 'left': `${gi*155}px` , 'top': 0}"
            >
          </Group>
          <Group 
            :key="`${tour.id}_${group}`"
            :name="GROUP_NAMES[group]" 
            :players="tour.groups[group+1]" 
            v-for="(group, gi) in [23, 24, 25]" 
            :style="{ 'left': `${gi*155}px` , 'top': '250px' }"
            >
          </Group>
        </div>
        <div class="l28-groups groups-round-1">
          <div class="l28-groups-box" :key="`${tour.id}_${group}`" v-for="(group, gi) in [7, 8, 9, 10, 11, 12, 13, 14]">
            <div class="vertical-line" :style="{ 'top':'-20px', 'left': `${gi*155+72}px` }"></div>
            <Group 
              :name="GROUP_NAMES[group]" 
              :players="tour.groups[group+1]" 
              :style="{ 'left': `${gi*155}px` }"
              >
            </Group>
            <div class="horizontal-line" :style="{ 'left': `${gi*155+72}px`, 'width': '157px' }" v-if="gi%2==0"></div>
          </div>
        </div>
        <div class="l28-groups groups-quarters">
          <div class="l28-groups-box" :key="`${tour.id}_${group}`"  v-for="(group, gi) in [3, 4, 5, 6]" >
            <div class="vertical-line" :style="{ 'top':'-20px', 'left': `${gi*310+72}px` }"></div>
            <Group 
              :name="GROUP_NAMES[group]" 
              :players="tour.groups[group+1]" 
              :style="{ 'left': `${gi*310}px` }"
              >
            </Group>
            <div class="vertical-line" :style="{ 'left': `${gi*310+72}px` }"></div>
            <div class="horizontal-line" :style="{ 'left': `${gi*310+72}px`, 'width': '312px' }" v-if="gi%2==0"></div>
          </div>
        </div>
        <div class="l28-groups groups-semi">
          <div class="l28-groups-box" :key="`${tour.id}_${group}`"  v-for="(group, gi) in [1, 2]" >
            <div class="horizontal-line" :style="{ 'left': `${gi*620+72}px`, 'width': '622px' }" v-if="gi%2==0"></div>
            <div class="vertical-line" :style="{ 'top':'-20px', 'left': `${gi*620+72}px` }"></div>
            <Group 
              :name="GROUP_NAMES[group]" 
              :players="tour.groups[group+1]" 
              :style="{ 'left': `${gi*620}px` }"
              >
            </Group>
            <div class="vertical-line" :style="{ 'left': `${gi*620+72}px` }"></div>
          </div>
        </div>
        
        <div class="l28-groups groups-final">
          <div class="l28-groups-box">
            <Group 
              :name="GROUP_NAMES[0]" 
              :players="tour.groups[0+1]" 
              :is_final="true"
            >
            </Group>
            <div class="vertical-line" :style="{ 'left': `67px` }"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import PageHeader from '@/components/game/pageheader.vue';
import {DatePicker, Select, Tag } from 'ant-design-vue';
import Vue from 'vue'
Vue.use(DatePicker)
Vue.use(Select)
Vue.use(Tag)

import moment from "moment";
import DataTable from '@/components/common/datatable.vue'
import Chart from '@/components/common/chart/chart.vue'
import Searcher from '@/components/common/search/searcher.vue'
import {ctrlMixin} from '@/utils/ctrlMixin.js'
import Group from './l28-lht-group.vue'
const GROUP_NAMES = ['Finalists', 'Half 1', 'Half 2', '1/4', '2/4', '3/4', '4/4', '1/8', '2/8', '3/8', '4/8', '5/8', '6/8', '7/8', '8/8', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K']

export default {
  mixins: [ctrlMixin],
  name:'l28-lht',
  props: ['parent', 'name'],
  components: {
    DataTable,
    Chart,
    Searcher,
    PageHeader,
    Group
  },
  mounted(){
    this.ds = moment()
    this.getData(this.ds.format('YYYY-MM-DD'))
  },
  data() {
    return {
      ds: moment(),
      tour_id: null,
      datas: [],
      GROUP_NAMES
    }
  },
  computed: {
    tours() {
      const tour_dict = {}
      this.datas.forEach(row=>{
        if(!tour_dict[row.tour_play_id]) {
          tour_dict[row.tour_play_id] = {
            id: row.tour_play_id,
            name: row.tour_name,
            time: row.ts,
            groups: {},
            clone: row.tour_id != row.tour_play_id
          }
        }
        if(row.ts < tour_dict[row.tour_play_id].time) {
          tour_dict[row.tour_id].time = row.ts
        }

        if(!tour_dict[row.tour_play_id].groups[row.phase_group]) {
          tour_dict[row.tour_play_id].groups[row.phase_group] = new Array(9)
        }
        tour_dict[row.tour_play_id].groups[row.phase_group][row.group_rank===0?8:row.group_rank-1] = row
      })
      const sorted_tour = Object.values(tour_dict).sort((a, b)=>{
        const atime = a.time.substring(0,14)
        const btime = b.time.substring(0,14)
        return atime < btime ? -1 : atime===btime? a.tour_id<b.tour_id?-1:a.tour_id===b.tour_id?0:1:1
      }).map(tour=>{
        if(tour.time) {
          const t = tour.time.split(' ')[1].split(':')
          if(parseInt(t[1])>=30) {
            t[1] = '30'
          }
          else {
            t[1] = '00'
          }
          tour.ts = `${t[0]}:${t[1]}`
          return tour 
        }
      })
      if(sorted_tour.length > 0) {
        this.tour_id = sorted_tour[sorted_tour.length - 1].id
      }
      return sorted_tour
    },
    tour() {
      return this.tours.find(tour=>tour.id == this.tour_id)
    }
  },
  methods: {
    disabledRangeDate(current) {
      console.log(current)
      return current && (current<moment('2023-09-14').endOf('day') || current > moment().endOf('day'));
    },
    // 获取页面数据
    getData(ds) {
      if(ds<='2023-09-01') {
        return
      }
      this.loading = true
      this.$service.query(this.$route.query.id, {ds}).then((data)=>{
        if(data[0].length === 0) {
          this.ds = this.ds.subtract(1, 'day')
          this.getData(this.ds.format('YYYY-MM-DD'))
        }
        else {
          this.datas = data[0]
          this.loading = false
        }
      }).catch((data)=> {
        this.loading = false
      })
    },
  }
}
</script>
<style lang="less">
.l28-lht {
  .page_header {
    border-bottom: none;
    .page_desc {
      padding-top:5px;
      padding-bottom:5px;
    }
  }
}
</style>
<style lang="less" scoped>

.l28_ctrl_container {
  width: 1400px;
  height: 1600px;
  margin: 0 auto;
  overflow: hidden;
  font-family: "Source Han Sans SC", "Source Han Sans CN", sans-apple-system, "Noto Sans", "Helvetica Neue", Helvetica, "Nimbus Sans L", Arial, "Liberation Sans", "PingFang SC", "Hiragino Sans GB", "Noto Sans CJK SC",  "Microsoft YaHei", "Wenquanyi Micro Hei", "WenQuanYi Zen Hei", "ST Heiti", SimHei, "WenQuanYi Zen Hei Sharp", sans-serif;

  .l28_tour_maps {
    position: relative;
    width: 1260px; 
    height: 100%;
    float: right;
  }
  .l28_tour_names {
    position: relative;
    width: 140px;
    height: 100%;
    float: left;
    > div {
      position: absolute;
      color: #fff;
      font-weight: bold;
      font-size: 20px;
      &:nth-child(1) {
        top: 1260px;
      }
      &:nth-child(2) {
        top: 885px;
      }
      &:nth-child(3) {
        top: 630px;
      }
      &:nth-child(4) {
        top: 365px;
      }
      &:nth-child(5) {
        top: 105px;
      }
    }
  }
  .l28-groups {
    position: absolute;
    .l28_tour_group {
      position: absolute;
    }
    h2 {
      font-size: 18px;
      color: #5877ff;
      font-weight: bold;
    }
    .horizontal-line {
      position: absolute;
      width: 100px;
      height: 2px;
      background: #fff;
      top: -20px;
      left: 67px;
    }
    .vertical-line {
      position: absolute;
      width: 2px;
      height: 20px;
      background: #fff;
      top: 220px;
      left: 67px;
    }
  }

  .groups-qualifier {
    position: relative;
    width: 100%;
    top: 1040px;
    left: 0px;
    &::before {
      position: absolute;
      content: ' ';
      width: 100%;
      height: 500px;
      border: 2px solid #ddd;
      top: -15px;
      left: -15px;
      background: #5789f2;
    }
  }

  .groups-round-1 {
    top: 780px;
    left: 0px;
    .l28-groups-lines {
      top: 220px;
    }
  }
  .groups-quarters {
    top: 520px;
    left: 80px;
  }
  .groups-semi {
    top: 260px;
    left: 235px;
  }
  .groups-final {
    top: 0px;
    left: 550px;
  }
}
</style>